"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodycodeModels = void 0;
const bodycode_1 = require("./bodycode");
exports.BodycodeModels = [
    bodycode_1.BodycodeModel,
];
